import React from 'react'
import { connect } from 'react-redux'
import CollegeDashboardContents from '../../Dashboard/CollegeDashboardContents'
import DetailsHolder from './DetailsHolder'

const CollegeDetails = ({ college }) => {
  return (
    <DetailsHolder
      college={college}
      activePath='/CollegeDetails'
    >
      <CollegeDashboardContents
        user={college.user}
        institution={college.institution}
        campuses={college.campuses}
        personnel={college.personnel}
        classes={college.classes}
        isViewAsAdmin={true}
      />
    </DetailsHolder>
  )
}

function mapStateToProps(state) {
  return {
    college: state.admin.college_details,
  }
}

export default connect(mapStateToProps)(CollegeDetails)
